import React from 'react';
import { motion } from 'framer-motion';
import { Calculator } from 'lucide-react';
export function DashboardHeader() {
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="text-center space-y-4 py-8" data-id="element-47">
      <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 rounded-full bg-white/[0.05] border border-salmon/20 mb-4" data-id="element-48">
        <Calculator className="w-4 h-4 text-salmon" data-id="element-49" />
        <span className="text-xs font-semibold tracking-widest text-salmon uppercase" data-id="element-50">
          Simulador en Tiempo Real
        </span>
      </div>
      <h1 className="text-3xl md:text-5xl lg:text-6xl font-black tracking-tight uppercase text-white neon-glow" data-id="element-51">
        Calculadora de Rentabilidad
        <br data-id="element-52" />
        <span className="text-salmon" data-id="element-53">Inmersión</span>
      </h1>
      <p className="text-base md:text-lg text-white/50 max-w-xl mx-auto font-medium" data-id="element-54">
        Ajusta los valores de tu operación y observa cómo cambian tus métricas
        al instante.
      </p>
    </motion.div>;
}